var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('service-view-right-menu-faqs',{attrs:{"service_id":_vm.service_id,"company_id":_vm.company_id,"company_name":_vm.company_name}}),_vm._v(" "),_c('service-view-right-menu-videos',{attrs:{"service_id":_vm.service_id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }